import { useFeatureIsOn } from "@growthbook/growthbook-react";

import Loading from "web/Layout/Common/Loading";

import { useGetCompanyDetailsQuery } from "web/features/company/companyApiSlice";

import MainHeaderDashboard from "./MainHeaderDashboard";
import MainHeaderDefault from "./MainHeaderDefault";

const MainHeaderContainer = () => {
  const { data: company, isLoading } = useGetCompanyDetailsQuery();
  const hasDashboardHeaderEnabled = company?.enableDashboardHeader;
  const shouldShowMessage = company?.displayMessageOneTimeLossPoints || false;
  const isDashboardMenuEnabled = useFeatureIsOn("pwa_dashboard_menu");

  if (isLoading) {
    return <Loading />;
  }

  return hasDashboardHeaderEnabled && isDashboardMenuEnabled ? (
    <MainHeaderDashboard shouldShowMessage={shouldShowMessage} />
  ) : (
    <MainHeaderDefault shouldShowMessage={shouldShowMessage} />
  );
};

export default MainHeaderContainer;
